import {readonly, ref} from 'vue';

// Refreshed on resume instead of ticking, so day-dependent state re-evaluates without a permanent timer.
const now = ref(Date.now());

export const wallClockNow = readonly(now);

export function refreshWallClock() {
    now.value = Date.now();
}
